var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5C3.13438 0.5 0 3.63438 0 7.5C0 11.3656 3.13438 14.5 7 14.5C10.8656 14.5 14 11.3656 14 7.5C14 3.63438 10.8656 0.5 7 0.5ZM10.0234 5.21406L6.73281 9.77656C6.68682 9.84076 6.62619 9.89306 6.55595 9.92914C6.48571 9.96523 6.40787 9.98405 6.32891 9.98405C6.24994 9.98405 6.17211 9.96523 6.10186 9.92914C6.03162 9.89306 5.97099 9.84076 5.925 9.77656L3.97656 7.07656C3.91719 6.99375 3.97656 6.87813 4.07812 6.87813H4.81094C4.97031 6.87813 5.12187 6.95469 5.21562 7.08594L6.32812 8.62969L8.78438 5.22344C8.87813 5.09375 9.02812 5.01562 9.18906 5.01562H9.92188C10.0234 5.01562 10.0828 5.13125 10.0234 5.21406Z",
    fill: "#52C41A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/CheckCircle.8044e891d24cb56602f47f8b5233cad8.svg";
export { ForwardRef as ReactComponent };